@if (!importing) {
  <div>
    <h1>Confirm Columns</h1>
    <p class="subheading">The following columns will be imported</p>
    <div class="flex" style="text-align: center;">
      <div class="flex-column wk-flex-fix" style="flex: 25%; margin-left: 25%;">
        <h3>YOUR FILE</h3>
      </div>
      <div class="flex-column wk-flex-fix" style="flex: 25%; margin-right: 25%;">
        <h3>IMPORTED AS</h3>
      </div>
    </div>
    <div>
      @for (field of importedFields; track field; let i = $index) {
        <div class="flex">
          <div class="flex-column space-between center wk-flex-fix" style="flex: 25%; margin-left: 25%;">
            <mat-card appearance="outlined" class="flex-column match-card">
              <div>
                {{ field }}
                <div class="example-text">{{ valueExamples[field] }}</div>
              </div>
            </mat-card>
          </div>
          <div class="flex-column space-between center wk-flex-fix" style="flex: 25%; margin-right: 25%;">
            <mat-card appearance="outlined" class="flex-column match-card">
              {{ fields[i] }}
            </mat-card>
          </div>
        </div>
      }
    </div>
    <div class="flex" style="margin-bottom: 100px;">
      <div class="flex-column space-between center wk-flex-fix" style="flex: 25%; margin-left: 25%;">
        <button mat-raised-button [disabled]="checking" (click)="onBack()">Cancel</button>
      </div>
      <div class="flex-column space-between center wk-flex-fix" style="flex: 25%; margin-right: 25%;">
        <button mat-raised-button [disabled]="checking" (click)="openImportSummary()">IMPORT</button>
        @if (checking) {
          <mat-spinner [diameter]="32" style="margin-left: 10px;"></mat-spinner>
        }
      </div>
    </div>
  </div>
}
@if (importing) {
  <div class="flex-column justify-flex-center center" style="height: 100%;">
    <mat-card appearance="outlined">
      <div>
        <h1>Creating Assets...</h1>
        <p class="subheading">Please wait, this may take a few minutes</p>
      </div>
      <div>
        <mat-spinner style="margin: 0 auto"></mat-spinner>
      </div>
    </mat-card>
  </div>
}
